// Import and add any new fontawesome fonts here
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faChartArea,
  faTable,
  faSort,
  faSortUp,
  faSortDown,
  faPrint,
  faDownload,
  faAngleRight,
  faArrowLeft,
  faMinusCircle,
  faPlusCircle,
  faUniversity,
} from "@fortawesome/free-solid-svg-icons";

export const addFonts = () =>
  library.add(
    faChartArea,
    faTable,
    faSort,
    faSortUp,
    faSortDown,
    faPrint,
    faDownload,
    faAngleRight,
    faArrowLeft,
    faMinusCircle,
    faPlusCircle,
    faUniversity,
  );
